/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Account Cashback History types
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

export interface ICashbackHistoryTableData {
    date: string;               // Дата и время
    operationType: string;      // Тип операций
    scores: number;             // Баллы кешбека
    service: string;            // Услуга
}

export enum CashbackHistoryTableField {
    date = 'date',
    operationType = 'operationType',
    scores = 'scores',
    service = 'service',
}

